import { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { uploadFiles } from 'src/api/csApi';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { LoadingButton } from '@mui/lab';
import { Divider, IconButton, Tooltip } from '@mui/material';

interface UploadButtonProps {
  fileUrl: string;
  disabled?: boolean;
  setFileUrl: (fileUrl: string) => void;
  tooltipContent?: string | undefined;
  text?: string;
}

export const UploadButton: FC<UploadButtonProps> = ({ fileUrl, disabled, setFileUrl, tooltipContent, text }) => {
  const [loading, setLoading] = useState(false);
  const ref = useRef();
  const { t } = useTranslation();

  const changeHandler = async (event: any) => {
    try {
      if (event.target.files.length >= 1) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        setLoading(true);
        const res = await uploadFiles(formData);
        setFileUrl(res.data.data.url);
      }
    } catch (e) {
      apiErrorHandling(e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <input
        ref={ref as any}
        type="file"
        name="file"
        onChange={changeHandler}
        style={{
          display: 'none',
        }}
        multiple={false}
        accept="image/*, application/pdf"
      />
      {fileUrl ? (
        <>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              maxHeight: '36.5px',
            }}
          >
            <IconButton
              onClick={() => {
                window.open(fileUrl, '_blank');
              }}
            >
              <FileDownloadOutlinedIcon />
            </IconButton>
            <Divider orientation="vertical" flexItem sx={{ margin: '0 4px' }} />
            <Tooltip title={disabled && tooltipContent ? tooltipContent : null}>
              <span>
                <IconButton onClick={() => setFileUrl('')} disabled={disabled}>
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </span>
            </Tooltip>
          </span>
        </>
      ) : (
        <LoadingButton
          loading={loading}
          color="inherit"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => (ref?.current as any)?.click()}
          disabled={disabled}
        >
          {text || t('components.uploadbutton.addfile')}
        </LoadingButton>
      )}
    </>
  );
};
